import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

type Props = {
    isDisabled?: boolean;
    onClick: () => void;
};

export const AddMarketButton = ({ isDisabled, onClick }: Props) => {
    const { translate } = useTranslate();

    return (
        <IconButton
            dataAutomation="gsc-add-market"
            type="flat"
            width="fit-content"
            isDisabled={isDisabled}
            iconName="add"
            placement="left"
            iconSize="xs"
            onClick={onClick}
        >
            {translate("rankTracker.gsc.addMarket")}
        </IconButton>
    );
};
